module.exports = __webpack_public_path__ + "img/step-advice.aa93638.svg";